import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { QuotesModalTableViewPricesFragmentDoc } from './QuotesModalTableViewPrices.generated'
import { QuotesModalTileViewPricesFragmentDoc } from './QuotesModalTileViewPrices.generated'
import * as Types from './purchasePlus_graphql'

export const QuotesModalListsPricesFragmentDoc = gql`
  fragment QuotesModalListsPrices on Price {
    uuid
    ...QuotesModalTableViewPrices
    ...QuotesModalTileViewPrices
  }
  ${QuotesModalTableViewPricesFragmentDoc}
  ${QuotesModalTileViewPricesFragmentDoc}
` as unknown as DocumentNode<Types.QuotesModalListsPricesFragment, unknown>
